// extracted by mini-css-extract-plugin
export default {"dashboard":"dashboard_dashboard__LcOxn","header":"dashboard_header__lxrmR"};